import { SearchEngineDataService } from 'src/app/_services/search-engine-data.service';
import { BillingService } from './../../_services/billing.service';
import { Component, OnInit, Optional } from '@angular/core';

@Component({
  selector: 'app-info-service-pricing',
  templateUrl: './info-service-pricing.component.html',
  styleUrls: ['./info-service-pricing.component.css']
})
export class InfoServicePricingComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  billingRates=[]
  constructor( private billingService:BillingService,@Optional() private metaDataService:SearchEngineDataService) { }

  ngOnInit(): void {
    this.billingService.getBillingInfo().subscribe(
      x=>{
        this.billingRates=x
      }
    )
      this.initMetaData()

    this.dtOptions = {
      pagingType: 'full_numbers'
     }
    }
     initMetaData(): void {
      if (this.metaDataService) {
        this.metaDataService.updateMetadata({
          keywords:["Smart-Kids Practice Tests Mathematics","Smart Math Techniques","Solve maths problems in seconds","Math Facts Pro","Awesome Apps for Math Practice","Math Workbooks for Math Practice"],
          author:"Boldungu Team"
        });
      }
    }
  }


